import { AlertType } from '@/enums/alertType'

class Alert {
  constructor(public message: string, public type: AlertType) {}
}

export default Alert
